module.exports = __webpack_public_path__ + "img/cw_ys_feiXiangGuoZhang.81580706.svg";